import DoAPICall from './DoAPICall'

//Create Dashboard
    export async function createDashboardSnippet(userToken, snippet){
            const apiPayload = {
                httpMethod:'post',
                userToken,
                uri:'dashboardsnippets',
                payLoad:{
                    generateHandler:snippet.generateHandler,
                    title:snippet.title,
                    name:snippet.name,
                    type:snippet.type,
                },
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }

//Get All dashboard
    export async function getDashboardSnippets(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'dashboardsnippets',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Dashboard
    export async function getDashboardSnippet(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'dashboardsnippets/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update Dashboard
    export async function updateDashboardSnippet(userToken, snippet){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'dashboardsnippets/'+snippet.id,
            payLoad:{
                generateHandler:snippet.generateHandler,
                title:snippet.title,
                name:snippet.name,
                type:snippet.type,
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete dashboard
    export async function deleteDashboardSnippet(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'dashboardsnippets/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }




